import React, { useEffect, useState } from 'react'
import { Image, Table } from 'react-bootstrap'
import Error_false from '../../error/error-false'
import { getMonthlyNewAPI } from '../../../services/employee'
import 'moment/locale/th'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import ImgUser from '../../../images/user.png'
import SpinnerLoading from '../../spinner-loading'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import { updateSizeMonthly } from '../../../actions/monthly.action'
import { ALLMENU } from '../../../Constants'
import fnCardMenu from '../../layouts/Menu/map-3-subListmenu'

export default function NewEmplloyeePage() {
  const roleId = useSelector((state) => state.roleReducer.role)
  const monthly = useSelector((state) => state.monthlyReducer.date)

  const [page, setPage] = useState(1)
  const [dataEmps, setDataEmps] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [totalRows, setTotalRows] = useState(0)
  const [totalLimits, setTotalLimits] = useState(20)

  const dispatch = useDispatch()
  // const menu = JSON.parse(localStorage.getItem(ALLMENU))
  // const [newMenu, setNewMenu] = useState([])

  // useEffect(() => {
  //   if (menu) {

  //   const filteredData = menu.flatMap((item) => {
  //     return item.sub_menus.flatMap((subMenu) => {
  //       return subMenu.menu_sub_list.filter((subItem) => {
  //         return subItem.id >= 3 && subItem.id <= 6
  //       })
  //     })
  //   })
  //   const result = filteredData.map((item) => fnCardMenu(item))

  //   setNewMenu(result)
  // }
  // }, [menu])

  useEffect(() => {
    const param = {
      page,
      orgId: roleId
    }
    const getEmps = async () => {
      const data = await getMonthlyNewAPI(param)
      setIsLoading(false)
      if (!data) return
      if (data.status) {
        setDataEmps(data.result)
        setTotalRows(data.totalRows)
        setTotalLimits(data.totalLimits)
        dispatch(updateSizeMonthly(data.totalRows))
      } else {
        Error_false(data)
        setTotalRows(0)
        setTotalLimits(20)
      }
    }
    if (roleId) {
      getEmps()
    }
  }, [page, roleId, monthly, dispatch])

  return (
    <>
      <Table hover>
        <thead
          className="bg-hrms text-white"
          style={{ position: 'sticky', top: '0px' }}
        >
          <tr className="fw-normal font-title-table">
            <th className="fw-normal">#</th>
            <th className="text-center fw-normal">Image</th>

            <th className="fw-normal">Code</th>
            <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
              Start Date
            </th>
            <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
              Name
            </th>
            <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
              Nickname
            </th>
            <th
              className="fw-normal text-center"
              style={{ whiteSpace: 'nowrap' }}
            >
              Group {/* สายงาน */}
            </th>
            <th className="fw-normal text-center">Department {/* แผนก */}</th>

            <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
              Position{/* ตำแหน่ง */}
            </th>
            <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
              Email/ Phone No.
            </th>
            <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
              Type
            </th>
          </tr>
        </thead>
        <tbody>
          {dataEmps.length > 0 ? (
            dataEmps.map((d, i) => (
              <tr className="mb-3 fw-light font-small-2" key={i}>
                <td>{page * totalLimits - totalLimits + i + 1}</td>
                <td lg={1} className="text-center">
                  <Image
                    fluid
                    className="rounded-circle "
                    style={{ maxWidth: 40, maxHeight: 40, objectFit: 'cover' }}
                    //src={`${URL_PROFILE}/${d?.folder_img}/${d?.code}_cr.jpg`}
                    src={`${d?.img_url}`}
                    onError={(event) => {
                      event.target.src = ImgUser
                      event.onerror = null
                    }}
                  />
                </td>
                <td>
                  <p className="font-small-2">{d.code}</p>
                </td>
                <td lg={1} className="c">
                  <p className="mb-1  font-small-2">
                    {' '}
                    {moment(d.start_date).format('DD/MM/YYYY')}
                  </p>
                </td>
                <td lg={2} className="my-auto ">
                  <p className="mb-0  font-small-2 ">
                    <span className="me-1">
                      {d.title_th}
                      {d.name_th}
                    </span>{' '}
                    <span>{d.surname_th}</span>
                  </p>
                </td>
                <td lg={1} className="my-auto">
                  <p className="mb-1  font-small-2"> {d.nickname_th}</p>
                </td>
                <td lg={1} className="my-auto text-center">
                  <p className="mb-1  font-small-2"> {d.division}</p>
                </td>
                <td lg={1} className="my-auto text-center">
                  <p className="mb-1  font-small-2"> {d.department}</p>
                </td>

                <td lg={2} className="my-auto">
                  <p className="mb-1  font-small-2"> {d.position_th}</p>
                </td>
                <td lg={2} className="my-auto">
                  <p className="mb-1  font-small-2"> {d.email}</p>
                  <p className="mb-0  font-small-2">{d.phone}</p>
                </td>
                <td lg={1} className="my-auto">
                  <p className="mb-1  font-small-2"> {d.type}</p>
                </td>
              </tr>
            ))
          ) : !roleId ? (
            <tr className="mb-0">
              <td className="text-center small" colSpan={13}>
                - ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -
              </td>
            </tr>
          ) : isLoading ? (
            <tr className="mb-0">
              <td className="text-center" colSpan={13}>
                <SpinnerLoading />
              </td>
            </tr>
          ) : (
            <tr className="mb-0">
              <td className="text-center" colSpan={13}>
                -ไม่มีข้อมูล-
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <div className="pt-3">
        <PaginationControl
          page={page}
          total={totalRows}
          limit={totalLimits}
          changePage={(page) => {
            setPage(page)
          }}
          ellipsis={1}
        />
      </div>
    </>
  )
}
